import * as React from 'react';
import { VerticalBarGraph } from '../../../designSystem/graphs/VerticalBarGraph';
import { SelectionStats } from '../../../amorg-common';
import { colors } from '../../../designSystem/colors/color';
import styled from 'styled-components';

type AnswerRatioVerticalGraphProps = {
    summaryStats:SelectionStats,
    showLegendText?:boolean
}
export function AnswerRatioVerticalGraph(props:AnswerRatioVerticalGraphProps):JSX.Element
{
    const total = props.summaryStats.totalSelections;

    function valueToPercent(value:number):string
    {
        return (value / total * 100).toFixed(0) + "%";
    }

    const v1 = props.summaryStats.data.value1Count;
    const v2 = props.summaryStats.data.value2Count;
    const v3 = props.summaryStats.data.value3Count;
    const v4 = props.summaryStats.data.value4Count;
    const v5 = props.summaryStats.data.value5Count;

    return (
        <VerticalBarGraph data={[
            { value: v1, color: colors.graphs.survey.answers.veryDissatisfied,
                legendText: props.showLegendText ? <Legend>Meget uenig {valueToPercent(v1)}</Legend> : undefined
            },
            { value: v2, color: colors.graphs.survey.answers.dissatisfied,
                legendText: props.showLegendText ? <Legend>Uenig {valueToPercent(v2)}</Legend> : undefined
            },
            { value: v3, color: colors.graphs.survey.answers.neutral,
                legendText: props.showLegendText ? <Legend>Neutral {valueToPercent(v3)}</Legend> : undefined
            },
            { value: v4, color: colors.graphs.survey.answers.satisfied,
                legendText: props.showLegendText ? <Legend>Enig {valueToPercent(v4)}</Legend> : undefined
            },
            { value: v5, color: colors.graphs.survey.answers.verySatisfied, 
                legendText: props.showLegendText ? <Legend>Meget enig {valueToPercent(v5)}</Legend> : undefined },
        ]} barHeightPx={100} heightMode={"total-sum"} />
    );
}

export const Legend = styled.span`
    font-size: 11px;
`;